import script from "./SpringFestivalLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./SpringFestivalLoading.vue?vue&type=script&setup=true&lang=js"

import "./SpringFestivalLoading.vue?vue&type=style&index=0&id=5f76a790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f76a790"]])

export default __exports__